import React from 'react';

export default function PageGenerator(props) {
  const { aside_list, ...otherProps } = props;
  const children = aside_list
    .map(({ acf_fc_layout, ...componentProps }, idx) => {
      try {
        const Component = require(`components/templates-aside/${acf_fc_layout}`).default;
        return <Component {...componentProps} {...otherProps} key={`${acf_fc_layout}-${idx}`} />;
      } catch (e) {
        return null;
      }
    })
    .filter(component => component);
  return <>{children}</>;
}
